import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageNames } from '../../../../shared/page-names.enum';
import { TvShopEntertainmentPack } from '../../../../model/tv-shop-entertainment-pack';
import { OrderOption } from '../../../../model/order-option';
import { PriceDetail } from '../../../../model/ocapi/price-detail';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { LanguageService } from '../../../../services/language/language.service';
import { Order } from '../../../../model/order';
import { PriceUtils } from '../../../../shared/utils/price/price.utils';
import { ImageUtils } from '../../../../shared/utils/image/image-utils';

@Component({
  selector: 'app-standalone-flavor-option',
  templateUrl: './standalone-flavor-option.component.html',
  styleUrls: ['./standalone-flavor-option.component.less']
})
export class StandaloneFlavorOptionComponent implements OnInit {
  ownerComponent = PageNames.STANDALONE_FLAVORS;
  @Input()
  x: number;
  @Input()
  y: number;
  @Input()
  omapiId: string;
  @Input()
  pack: TvShopEntertainmentPack;
  @Input()
  orderOption: OrderOption;
  @Input() badgeCopyKey: string;

  @Output()
  emitOrderProduct = new EventEmitter<Object>();
  @Output()
  emitOnBack = new EventEmitter<Object>();

  active: boolean;

  name: string;
  label = 'eos-tv-shop-ii.title.standalone-flavor-options-order';

  priceDetail: PriceDetail;

  constructor(private navigationService: NavigationService,
              private languageService: LanguageService) {
  }

  ngOnInit(): void {
    this.priceDetail = this.orderOption ? this.orderOption.priceDetail : undefined;
  }

  activate(active: boolean): void {
    this.active = active;
  }

  get hasPromo(): boolean {
    return this.orderOption.priceDetail && this.orderOption.priceDetail.hasPromo();
  }

  get promoLabel(): string {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoLabel : undefined;
  }

  get promoDuration(): number {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoDuration : undefined;
  }

  get textIntegerPart(): string {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.price.integerPart() : undefined;
  }

  get textDecimalPart(): string {
    return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.price.decimalPart() : undefined);
  }

  get priceBeforeComma(): string {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.integerPart() : undefined;
  }

  get getPriceTextDecimalPart(): string {
    return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.decimalPart() : undefined);
  }

  get standAloneOptionLogoUrl(): string {
    return ImageUtils.getLogoUrlForOmapiId(this.orderOption.omapiId + '-flavor-option');
  }

  public onEmitOrderProduct(event: Order): void {
    this.emitOrderProduct.emit(event);
  }

  onBack(): void {
    this.emitOnBack.emit();
  }

  get getCurrentLang(): string {
    return this.languageService.getCurrentLanguage().toLowerCase();
  }

  private getTextDecimalPart(price: string): string {
    const sign = this.getCurrentLang === 'fr' ? ' €' : '';
    return PriceUtils.prefixDecimalPart(price, this.getCurrentLang) + sign;
  }
}
